export default __webpack_public_path__ + "static/media/NH10.79e5e5a1.jpg";